module.exports = __webpack_public_path__ + "img/anejo-16-informe-de-bajas.00659bcd.svg";